import { mynaviTheme } from '@/theme/mynavi'

/** MYNAVI プライマリカラー（単一ソースは `@/theme/mynavi` の mynaviTheme.primary） */
export const MYNAVI_PRIMARY = mynaviTheme.primary
